import { lazy } from "react";

export const About = lazy(() => import("./About"));
export const Learn = lazy(() => import("./Learn"));
export const ContactUs = lazy(() => import("./ContactUs"));
export const PrivacyPolicy = lazy(() => import("./PrivacyPolicy"));
export const TermsConditions = lazy(() => import("./TermsConditions"));

